import { render, staticRenderFns } from "./academic_paper_management_home.vue?vue&type=template&id=0b5952ed&scoped=true&"
import script from "./academic_paper_management_home.vue?vue&type=script&lang=js&"
export * from "./academic_paper_management_home.vue?vue&type=script&lang=js&"
import style0 from "./academic_paper_management_home.vue?vue&type=style&index=0&id=0b5952ed&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5952ed",
  null
  
)

export default component.exports